module.exports = __webpack_public_path__ + "img/11.6d221c4b.png";